import React from "react";
import { Title } from "../../components/Title";
import { Link } from "../../components/Link";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const PriceQuestion = () => {
  const { t } = useTranslation();
  return (
    <div className="price-question">
      <Title title={t("price.question.title")}>
        {t("price.question.subtitle")}
      </Title>
      <div className="question-list">
        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {t("price.question.item-one.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-one.descript")}
              <a
                href="https://blog.authing.cn/blog/为什么所有软件都应该使用单点登录来管理用户/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("price.question.item-one.link")}
              </a>
            </div>
          </div>
        </div>

        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {t("price.question.item-two.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-two.descript")}
            </div>
          </div>
        </div>

        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {" "}
              {t("price.question.item-three.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-three.descript")}
            </div>
          </div>
        </div>

        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {t("price.question.item-four.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-four.other")}
              <ul>
                <li>{t("price.question.item-four.descript-one")}</li>
                <li>{t("price.question.item-four.descript-two")}</li>
                <li>{t("price.question.item-four.descript-three")}</li>
                <li>{t("price.question.item-four.descript-four")}</li>
              </ul>
              <a
                href="https://docs.authing.cn/v2"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("price.question.item-four.link")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
